/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { fetchUser } from '@zoopla/redux-reducer-user';

export const useFetchUser = () => {
    const reduxDispatch = useDispatch();

    useEffect(() => {
        reduxDispatch(fetchUser());
    }, []);
};
